const CLOSE_BUTTON_SELECTOR = '.close-button';
const DEFAULT_MODAL_ID = 'modal-signup';
const MODAL_OVERLAY_SELECTOR = '.modal-overlay';
const MODAL_SELECTOR = '.modal';
const MODAL_TRIGGER_SELECTOR = '.button-modal-trigger';

let _savedScrollTopReference = 0;

function _lockPageBehindModal() {
  _savedScrollTopReference = document.scrollingElement.scrollTop;

  document.body.style.position = 'fixed';
  document.body.style.top = `-${_savedScrollTopReference}px`;
  document.body.style.width = '100%';
}

function _unlockPageBehindModal() {
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.width = '';
  document.scrollingElement.scrollTop = _savedScrollTopReference;

  _savedScrollTopReference = null;
}

export default class ModalManager {
  constructor() {
    this.initModalDismissActions();
    this.initModalTriggers();
  }

  dismissModal(evt) {
    const modalEl = evt.target.closest(MODAL_SELECTOR);
    this.toggleModalDisplay(modalEl, false);
  }

  initModalDismissActions() {
    const modals = document.querySelectorAll(MODAL_SELECTOR);
    modals.forEach(m => {
      const overlayEl = m.querySelector(MODAL_OVERLAY_SELECTOR);
      overlayEl.addEventListener('click', this.dismissModal.bind(this));

      const closeButton = m.querySelector(CLOSE_BUTTON_SELECTOR);
      if (!closeButton) return;
      closeButton.addEventListener('click', this.dismissModal.bind(this));
    });
  }

  initModalTriggers() {
    const modalTriggers = document.querySelectorAll(MODAL_TRIGGER_SELECTOR);
    modalTriggers.forEach(mt => {
      mt.addEventListener('click', this.modalTriggerClickPerformed.bind(this));
    });
  }

  modalTriggerClickPerformed(evt) {
    const triggerEl = evt.target;

    const targetModalId = triggerEl.dataset.modalId || DEFAULT_MODAL_ID;
    const modalEl = document.getElementById(targetModalId);
    this.toggleModalDisplay(modalEl, true);
  }

  toggleModalDisplay(modalEl, shouldDisplay) {
    if (!modalEl) return;

    if (shouldDisplay) {
      modalEl.style.display = '';
      _lockPageBehindModal();
      return;
    }

    _unlockPageBehindModal();
    modalEl.style.display = 'none';
  }
}
